import type { AxiosResponse } from 'axios';
import { useCallback, useState } from 'react';
import type { DokladyDokladDto, DokladyDokladSeznamDto } from '@gov-nx/api';
import {
	identityDocumentQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { GovError } from '@gov-nx/core/app';
import type { Optional } from '@gov-nx/core/types';
import { propEqPartial } from '@gov-nx/core/types';

interface IdentityDocumentLoadHookProps {
	onError?: (error: GovError) => void;
	onSuccess?: (response: AxiosResponse<DokladyDokladSeznamDto>) => void;
}

export const useIdentityDocumentLoad = (
	props?: IdentityDocumentLoadHookProps
) => {
	const [documents, setDocuments] = useState<DokladyDokladDto[]>([]);
	const { axiosInstance } = useAxiosInstance();

	usePoQuery({
		queryKey: ['doklady'],
		queryFn: async () => identityDocumentQuery(axiosInstance),
		onSuccess: (response) => {
			setDocuments(response.data.seznam || []);

			if (props?.onSuccess) {
				props?.onSuccess(response);
			}
		},
		onError: async (err) => {
			if (props?.onError) {
				return props.onError(new GovError(err.message));
			}
		},
	});

	const getMainDocument = useCallback((): Optional<DokladyDokladDto> => {
		const kind = propEqPartial<DokladyDokladDto>('druhDokladu');

		return documents?.find(kind('ID')) || documents?.find(kind('P'));
	}, [documents]);

	return { getMainDocument, documents };
};
